const state = {
    loading: false,
}
const mutations = {
    SHOW_LOADING(state) {
        state.loading = true;
    },
    HIDE_LOADING(state) {
        state.loading = false;
    }
}

export default {
    state,
    mutations,
};
